import axios from "axios";
import { APP_PATH } from "../api/backendPath";

const useRefreshToken = () => {
  const refresh = async () => {
    // Read tokens at call time, not at hook creation time
    // This ensures we always use the latest rotated token
    const access_token = sessionStorage.getItem("usr_1a2b3c");
    const refresh_token = sessionStorage.getItem("usr_4d5e6f");

    if (!refresh_token) return null;

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APP_PATH.refreshToken,
        { refresh_token },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${access_token}`,
            "User-Refresh-Token": refresh_token,
            "Content-Type": "application/json",
          },
        },
      );

      const data = response?.data?.data;
      if (data?.access_token && data?.refresh_token) {
        // Persist rotated tokens immediately
        sessionStorage.setItem("usr_1a2b3c", data.access_token);
        sessionStorage.setItem("usr_4d5e6f", data.refresh_token);
      }
      return data;
    } catch (error) {
      console.error("Token refresh failed:", error);
      return null;
    }
  };

  return refresh;
};

export default useRefreshToken;
